import Component from "../lib/Component";

export default class ScrollBar extends Component {
	static selector = ".js-scroll-bar";

	initialize() {
		this.el = this.$el;

		this.DOM = {
			el: this.el,
			scrollTrack: this.el.querySelector(".c-scroll-bar__track-inner")
		};

		window.addEventListener("scroll", () => {
			const scrollPercent =
							(window.pageYOffset /
							 (document.body.scrollHeight - window.innerHeight)) *
							100;

			this.DOM.scrollTrack.style.height = `${scrollPercent}%`;
		});
	}
}
